<template>
    <Launcher
        :alwaysScrollToBottom="alwaysScrollToBottom"
        :close="() => closeChat(false, true)"
        :colors="colors"
        :isOpen="isChatOpen"
        :messageList="messages"
        :messageStyling="messageStyling"
        :newMessagesCount="newMessagesCount"
        :onMessageWasSent="onMessageWasSent"
        :open="openChat"
        :participants="participants"
        :sendTyping="sendTyping"
        :showCloseButton="true"
        :showEmoji="true"
        :showFile="false"
        :showLauncher="true"
        :showTypingIndicator="showTypingIndicator"
        @edit="editMessage"
        @onType="handleOnType"
        @remove="removeMessage"
        :chatbot-active="chatbotActive"
    >
        <template v-slot:text-message-toolbox="scopedProps">
            <button
                v-if="!scopedProps.me && scopedProps.message.type === 'text'"
                @click.prevent="like(scopedProps.message.id)"
            >
                👍
            </button>
        </template>
        <template v-slot:text-message-body="scopedProps">
            <div class="sc-message--text-content-wrapper">
                <span class="sc-message--text-content" v-html="scopedProps.messageText"></span>
                <span v-if="scopedProps.message.data.meta" class="sc-message--meta">{{
                    scopedProps.message.data.meta
                }}</span>
                <span v-if="scopedProps.message.isEdited || scopedProps.message.liked" class="sc-message--edited">
                    <template v-if="scopedProps.message.isEdited">✎</template>
                    <template v-if="scopedProps.message.liked">👍</template>
                </span>
            </div>
        </template>
        <template v-slot:header></template>
    </Launcher>
</template>

<script>
import Launcher from "./../V2/popup-chat/Launcher";
import { mapActions, mapState } from "vuex";
import { removePersistenceData } from "../../utils/persistenceStorage";
import { sendSocketMessage, socketMessageStream } from "../../utils/socketStream";
import { log2 } from "../../utils/log2";
import { filter, map } from "rxjs/operators";
import { systemMessageStream } from "../../utils/systemPubSub";
import { sendCommandToParentWindow } from "../../utils/parentWindowConnection";

const log = log2("Chat2");

export default {
    name: "ChatV2",
    components: {
        Launcher,
    },
    data() {
        return {
            newMessagesCount: 0,
            isChatOpen: true,
            showTypingIndicator: "",
            colors: {
                header: {
                    bg: "#4e8cff",
                    text: "#ffffff",
                },
                launcher: {
                    bg: "#4e8cff",
                },
                messageList: {
                    bg: "#ffffff",
                },
                sentMessage: {
                    bg: "#4e8cff",
                    text: "#ffffff",
                },
                receivedMessage: {
                    bg: "#eaeaea",
                    text: "#222222",
                },
                userInput: {
                    bg: "#f4f7f9",
                    text: "white",
                },
            },

            chosenColor: null,
            alwaysScrollToBottom: true,
            messageStyling: true,
            userIsTyping: false,
            title: "",
            isEditing: false,
        };
    },
    created() {
        this.chatCloseSub = systemMessageStream
            .pipe(
                filter((x) => x.type === "close-chat"),
                map((x) => x.payload)
            )
            .subscribe((x) => {
                this.closeChat(x.chatbot, true);
            });
    },
    destroyed() {
        this.chatCloseSub.unsubscribe();
    },
    methods: {
        ...mapActions({
            connectChat: "chat/connectChat",
            disconnectChat: "chat/disconnect",
            resetConversation: "chat/resetConversation",
            setConnectionStatus: "chat/setConnectionStatus",
            toggleAfterActions: "app/toggleAfterActions",
            toggleCloseChatConfirmation: "app/toggleCloseChatConfirmation",
        }),
        handleTyping(text) {
            this.showTypingIndicator = text.length > 0 ? this.participants[this.participants.length - 1].id : "";
        },
        onMessageWasSent(message, isMenu = false) {
            this.sendMessage(message, false, isMenu);
            //this.messageList = [...this.messageList, Object.assign({}, message, {id: Math.random()})]
        },
        openChat() {
            this.isChatOpen = true;
            this.newMessagesCount = 0;
        },
        closeChat(chatbot = false, sendFeedbackToSocket = true) {
            log("closeChat called", {
                chatbot,
                sendFeedbackToSocket,
                connected: this.connected,
            });
            if (this.connected) {
                if (sendFeedbackToSocket) {
                    const socketMessage = chatbot ? "chatbot destroy-chat" : "visitor destroy";

                    sendSocketMessage(socketMessage, {
                        visitorId: this.visitorId,
                        conversationId: this.conversationId,
                        siteId: this.site._id,
                    });
                }
                sendCommandToParentWindow("visitor-disconnected");
                // this.disconnectChat();
                this.toggleCloseChatConfirmation(false);
                this.toggleAfterActions(true);
                removePersistenceData("conversationId");
                this.onClosed();
            } else {
                /*this.isChatOpen = false;*/
                this.onClosed();
            }
        },

        handleOnType() {
            this.$root.$emit("onType");
            this.userIsTyping = true;
        },
        editMessage(message) {
            log("editMessage todo");
            /*const m = this.messageList.find(m => m.id === message.id);
            m.isEdited = true;
            m.data.text = message.data.text;*/
        },
        removeMessage(message) {
            log("removeMessage todo");
            /*if (confirm('Delete?')) {
                const m = this.messageList.find(m => m.id === message.id);
                m.type = 'system';
                m.data.text = 'This message has been removed';
            }*/
        },
        like(id) {
            log("like todo");
            /*const m = this.messageList.findIndex(m => m.id === id);
            var msg = this.messageList[m];
            msg.liked = !msg.liked;
            this.$set(this.messageList, m, msg);*/
            this.sendMessage("👍");
        },
    },
    computed: {
        ...mapState({
            connected: (state) => state.chat.connected,
            visitorId: (state) => state.chat.visitorId,
            conversationId: (state) => state.chat.conversationId,
            site: (state) => state.site.site,
        }),
    },
    props: {
        messages: {
            type: Array,
            default: () => [],
        },
        participants: {
            type: Array,
            default: () => [],
        },
        sendMessage: {
            type: Function,
        },
        onClosed: {
            type: Function,
            default: () => {},
        },
        sendTyping: {
            type: Function,
            default: () => {},
        },
        chatbotActive: {
            type: Boolean,
            default: false,
        },
    },
    beforeDestroy() {
        this.destroyedChatSub.unsubscribe();
    },
    mounted() {
        /*this.messageList.forEach(x => x.liked = false);*/
        log("Chat2 mounted", this.messages);
        this.destroyedChatSub = socketMessageStream
            .pipe(
                filter((x) => x.cmd === "conversation_destroyed"),
                map((x) => x.data)
            )
            .subscribe((x) => {
                this.closeChat(false, false);
            });
    },
};
</script>

<style>
body {
    padding: 0px;
    margin: 0px;
}

.demo-description img {
    max-width: 500px;
}

.colors a {
    color: #fff;
    text-decoration: none;
    padding: 4px 10px;
    border-radius: 10px;
}

.toggle a {
    text-decoration: none;
}

.sc-message--text-content-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    /*align-items: center;*/
}
</style>



// WEBPACK FOOTER //
// src/components/V2/Chat.vue